var akTargetGroups = require ('./targetGroups.json')
var akBusinessAreas = require ('./businessAreas.json')
var akMarketingContexts = require ('./marketingContexts.json')

var priorityContexts = akMarketingContexts.priority_contexts
var featureContexts = akMarketingContexts.feature_contexts

exports.akTargetGroups = akTargetGroups
exports.akBusinessAreas = akBusinessAreas
exports.akMarketingContexts = akMarketingContexts
exports.akFeatureContexts = featureContexts
exports.akPriorityContexts = priorityContexts
